import { trimEndSlash } from '../../Client/utils/string.js';

const AutoSyncKey = 'offroadrimfinance';

const baseFitmentFields = ['Year', 'Make', 'Model', 'Submodel', 'Suspension', 'Chassis'];
const extraFitmentFields = [];
const wheelsFields = ['wheel_tire_diameter', 'wheel_width', 'wheel_bolt_pattern'];
const tiresFields = ['tire_width', 'tire_aspect', 'wheel_tire_diameter'];
const ignoreFields = [...wheelsFields, ...tiresFields, 'wheel_aggressive', 'FilterByVehicle'];

const categorySelectionPageUrl = '/categories';
const brandSelectionPageUrl = '/brands';

const isCategorySelectionPage = trimEndSlash(window.location.pathname) === categorySelectionPageUrl;
const isBrandSelectionPage = trimEndSlash(window.location.pathname) === brandSelectionPageUrl;

const isCategoryPage =
  window.document.body.classList.contains('tax-product_cat') || window.location.pathname.startsWith('/shop');
const isBrandPage = window.document.body.classList.contains('tax-pa_brand');

// https://www.offroadrimfinancing.com/wp-admin/term.php?taxonomy=product_cat&tag_ID=23901
const isWheelTirePackagesPage = window.document.body.classList.contains('term-23901');

const InitFunc = () => {
  function updateFragments(e) {
    const { fragments } = e.detail;
    if (fragments) {
      Object.keys(fragments).forEach((selector) => {
        const element = document.querySelector(selector);
        if (element) {
          element.outerHTML = fragments[selector];
        }
      });
      const event = new CustomEvent('wc_fragments_loaded');
      document.body.dispatchEvent(event);
    }
  }

  if (!!document.getElementById('cm_results') || isCategoryPage || isBrandPage) {
    document.body.addEventListener('added_to_cart', updateFragments);
  }
};

const onVerifyFitmentResponseReceived = (response) => {
  if (window.document.body.classList.contains('product-template-default')) {
    const productClassList = [...window.document.querySelector('#main .product-type-simple').classList];
    const packageButton = window.document.querySelector('.cm_package-button-container');

    if (productClassList && !packageButton) {
      const { Items: items } = response;
      const [, productId] = productClassList.find((c) => c.includes('post-')).split('-');
      const [, productCategory] = productClassList.find((c) => c.includes('product_cat-')).split('-');

      if (productCategory && (productCategory === 'wheels' || productCategory === 'tires')) {
        const $ = jQuery;

        const mountedPackageButton = document.createElement('div');

        mountedPackageButton.innerHTML = `
        <div class="cm_package-button-container">
          <button
            value="${productId}"
            type="submit"
            name="add-to-cart"
            class="button alt cm_package-button single_add_to_cart_button"
          >
            Build Your Wheel & Tire Set
          </button>
        </div>
        `;

        document.body.querySelector('.cart').appendChild(mountedPackageButton.firstElementChild);

        document.body.querySelector('.cm_package-button').addEventListener('click', () => {
          $(document).on('added_to_cart', () => {
            // handle 'package button' logic on the single product page
            const categoryPath =
              productCategory === 'wheels'
                ? `tires/?WheelProductID`
                : productCategory === 'tires'
                  ? `wheels/?TireProductID`
                  : null;

            if (productId && categoryPath) {
              const redirectUrl = `/${categoryPath}/${productId}/${window.Convermax.getVehicleSearchParams()}`;

              const queryString = window.location.search;
              const urlParams = new URLSearchParams(queryString);
              const isPackagesMode = urlParams.get('PackagesMode');

              if (isPackagesMode === 'lastStep') {
                window.location.replace('/cart/');
              } else {
                window.location.replace(redirectUrl);
              }
            }
          });
        });
      }
    }
  }
};

function getLocalPreselection() {
  const pageHeader = document.querySelector('h1.wp-block-kadence-advancedheading')?.innerHTML;

  if (isCategoryPage && window.cm_category) {
    return [
      {
        field: 'categories',
        term: window.cm_category,
        treeLevel: window.cm_category.split('>').length - 1,
      },
    ];
  } else if (isBrandPage && pageHeader) {
    return [
      {
        field: 'brand',
        term: pageHeader,
      },
    ];
  }

  return null;
}

const fieldsForRelated = ['categories', ...wheelsFields, ...tiresFields];
function getSelection(itemData) {
  return fieldsForRelated.flatMap((field) => {
    const value = itemData[field];
    return !value
      ? []
      : Array.isArray(value)
        ? value.map((term) => ({ field, term }))
        : { field, term: value };
  });
}

export default {
  platform: 'woocommerce',
  searchPageUrl: '/search',
  getLocalPreselection,
  InitFunc,
  SearchRequestDefaults: {
    pageSize: 36,
    extra: isWheelTirePackagesPage ? { isWheelTirePackagesPage: true } : {},
  },
  page: {
    getPageType(defaults) {
      return isCategoryPage
        ? 'category'
        : isBrandSelectionPage || isCategorySelectionPage
          ? 'parts'
          : isBrandPage
            ? 'brand'
            : defaults.getter();
    },
  },
  product: {
    noImageSrc: '/wp-content/uploads/woocommerce-placeholder-300x300.png',
  },
  facets: {
    toggleFacet: [{ fields: 'ships_fast', term: 'True' }],
    rangedFacet: [{ fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } }],
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: categorySelectionPageUrl, field: 'categories' },
      { pathname: brandSelectionPageUrl, field: 'brand' },
    ],
    categorySelectionPageRedirect: true,
    isVehicleSelectionIsolated: true,
    onVerifyFitmentInitResponseReceived: onVerifyFitmentResponseReceived,
    onVerifyFitmentResponseReceived,
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: { selector: '#cm_results', class: 'site-container content-area' },
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: { replace: '.products, .woocommerce-no-products-found' },
      template: 'SearchPage',
      visibleIf: () => isCategoryPage || isBrandPage,
    },
    {
      name: 'SearchHeader',
      sortEntries: {
        'relevance': 'Best Match',
        'total_sales:desc': 'Most Popular',
        'name': 'A to Z',
        'name:desc': 'Z to A',
        'price': 'Price: Ascending',
        'price:desc': 'Price: Descending',
      },
    },
    {
      name: 'SearchResult',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        replace: '#main-header .site-header-item[data-section="kadence_customizer_header_search_bar"]',
        class: 'cm_search-box-root_container site-header-item site-header-focus-item',
      },
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'SearchBoxDialogButtonMobile',
      type: 'SearchBoxDialogButton',
      location: {
        replace:
          '#mobile-header .site-header-item[data-section="kadence_customizer_header_search"] .search-toggle-open',
        class: 'search-toggle-open drawer-toggle search-toggle-style-bordered',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: {
        insertAfter: '.site-bottom-header-inner-wrap',
        class: 'cm_vehicle-widget__header_container',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      visibleIf: () => !document.querySelector('body.home'),
      initCollapsed: true,
      columnBreakpoint: 700,
    },
    {
      name: 'HeaderVehicleWidget_mobile',
      type: 'VehicleWidget',
      location: {
        lastChildOf: '.site-mobile-header-wrap',
        class: 'cm_vehicle-widget__header_container',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      visibleIf: () => !document.querySelector('body.home'),
      initCollapsed: true,
      columnBreakpoint: 700,
    },
    {
      name: 'HomeVehicleWidget_tab',
      type: 'VehicleWidget',
      location: { selector: '#cm-home-ymm', class: 'cm_vehicle-widget__home-wheeltiretab' },
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 730,
    },
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: { selector: '#cm-home-wheel', class: 'cm_vehicle-widget__home-wheeltiretab' },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      redirectUrl: '/wheels/',
      selectFields: wheelsFields,
    },
    {
      name: 'TirePanel_tab',
      type: 'RequestPanel',
      location: { selector: '#cm-home-tire', class: 'cm_vehicle-widget__home-wheeltiretab' },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      redirectUrl: '/tires/',
      selectFields: tiresFields,
    },
    {
      name: 'VerifyFitment',
      location: {
        insertAfter: '.cart',
        class: 'cm_vehicle-widget__verify-fitment-container',
      },
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FitmentTable',
      location: '#cm_fitment-table',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'Garage',
      location: {
        insertBefore: '#main-header .site-header-item[data-section="kadence_customizer_cart"]',
        class: 'cm_garage__desktop site-header-item site-header-focus-item',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'MobileGarage',
      type: 'Garage',
      location: {
        insertBefore: '#mobile-header .site-header-item[data-section="kadence_customizer_mobile_cart"]',
        class: 'cm_garage__mobile site-header-item site-header-focus-item',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
      minFacetCount: 2,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
      minFacetCount: 2,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: { selector: '#cm_brands', class: 'site-container content-area' },
      template: 'facetTiles/alphabeticalContainer',
      view: 'grid',
      isVehicleWidgetDisabled: true,
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '#cm_categories',
      template: 'facetTiles/hierarchicalContainer',
      isVehicleWidgetDisabled: true,
    },
    {
      name: 'RelatedItems',
      location: 'body.product-template-default .related.products',
      template: 'product/relatedItems',
      count: 4,
      getSelection,
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter'],
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'WheelTireVehicleInfo',
      autoSyncVisualization: {
        apiKey: AutoSyncKey,
      },
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
      ignoreFields: ['wheel_aggressive', 'FilterByVehicle'],
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
    {
      name: 'AutoSyncVisualizationDialog',
      apiKey: AutoSyncKey,
      template: 'fitmentSearch/autoSyncVisualizationDialog',
    },
  ],
};
